import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DefaultTextField from 'components/Utils/DefaultTextField';
import { changePhoneSchema, ChangePhoneValues } from 'types/forms';

const ChangePhone = ({ patient, onSuccess }: { patient: any; onSuccess?: () => void }) => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [sentCode, setSentCode] = useState(false);
  const [changingPhone, setChangingPhone] = useState(false);

  const { control, handleSubmit } = useForm<ChangePhoneValues>({
    resolver: zodResolver(changePhoneSchema),
    defaultValues: { phone: '', code: '' },
  });

  async function sendPhoneVerification(values: ChangePhoneValues, resend = false) {
    const { phone } = values;

    setLoading(true);
    const result = await dispatch(api.Authentication.sendPhoneVerification({ phone, resend }), {
      errorTitle: 'Change Phone',
    });
    setLoading(false);

    if (result) {
      setSentCode(true);
    }
  }

  async function changePhoneNumber(values: ChangePhoneValues) {
    const { phone, code } = values;

    setChangingPhone(true);
    const result = await dispatch(
      api.Patients.changePhoneNumber({ id: patient.id, phone, stringResource: { value: code } }),
      {
        title: 'Change Phone',
        successText: 'Your phone has been changed successfully!',
      },
    );
    setChangingPhone(false);

    if (result && onSuccess) onSuccess();
  }

  return (
    <div className="change-phone">
      {!sentCode && (
        <form
          className="change-phone-form"
          onSubmit={handleSubmit((values) => sendPhoneVerification(values))}
        >
          <DefaultTextField name="phone" control={control} label="Phone" style={{ width: '100%' }} />
          <DefaultButton
            id="change-phone-send-confirmation"
            name="Send Confirmation Code"
            style={{ width: '100%', marginTop: '27px' }}
            loading={loading}
          />
        </form>
      )}
      {sentCode && (
        <React.Fragment>
          <span className="center-text">A confirmation code has been sent to your phone.</span>
          <form id="change-password-form" onSubmit={handleSubmit(changePhoneNumber)}>
            <DefaultTextField
              name="phone"
              control={control}
              label="Phone"
              style={{ width: '100%' }}
              disabled
            />
            <DefaultTextField
              name="code"
              control={control}
              label="Confirmation Code"
              style={{ width: '100%' }}
            />
            <DefaultButton
              id="change-phone-submit"
              name="Change Phone"
              style={{ width: '100%', marginTop: '20px' }}
              loading={changingPhone}
              disabled={loading}
            />
          </form>
          <DefaultButton
            name="Resend Code"
            onClick={handleSubmit((values) => sendPhoneVerification(values, true))}
            style={{ width: '100%', marginTop: '20px' }}
            className="blue"
            loading={loading}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default ChangePhone;
